<div class="container">
  <app-loading [showLoading]="isLoading || isSaving"></app-loading>
  <h1 class="header">
    <div class="title">連携タグ設定</div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      aria-label="閉じる"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div class="main">
    <p class="description">
      自社側の番号に応じて、BIZTEL
      から取り込んだアセスメントに商談タグを自動で付与します（着信:
      顧客がかけた先の窓口の番号 / 発信:
      相手に表示される自社の番号）。設定の変更は保存後の取り込み分から適用されます。
    </p>

    @if (loadError) {
      <div class="input-error">{{ loadError }}</div>
    } @else if (!isLoading) {
      @if (hasNoTagMasters) {
        <p class="no-tag-masters-note">
          商談タグが未作成のため、番号へのタグ付けはまだ設定できません。タグは管理者が作成します。
        </p>
      }
      <form (submit)="onSubmit($event)">
        <div class="tag-mapping-lists">
          @for (section of sections; track section.title) {
            <div class="tag-mapping-section">
              <h2 class="list-title">
                {{ section.title }}（{{ section.numberLabel }}）
              </h2>
              <p class="list-description">{{ section.description }}</p>

              @for (row of section.formArray.controls; track row) {
                <div class="mapping-row">
                  <div class="input-with-error number-cell">
                    <input
                      class="input"
                      inputmode="numeric"
                      [class.error]="
                        row.controls.phoneNumber.touched &&
                        (row.controls.phoneNumber.invalid ||
                          isDuplicatePhoneNumber(section.formArray, $index))
                      "
                      [placeholder]="section.placeholder"
                      [attr.aria-label]="section.numberLabel"
                      [formControl]="row.controls.phoneNumber"
                    />
                    @if (row.controls.phoneNumber.touched) {
                      @if (row.controls.phoneNumber.hasError('required')) {
                        <div class="input-error">番号を入力してください</div>
                      } @else if (
                        row.controls.phoneNumber.hasError('digitsOnly')
                      ) {
                        <div class="input-error">
                          番号は数字のみで入力してください
                        </div>
                      } @else if (
                        row.controls.phoneNumber.hasError('maxLength')
                      ) {
                        <div class="input-error">
                          番号は 20 桁以内で入力してください
                        </div>
                      } @else if (
                        isDuplicatePhoneNumber(section.formArray, $index)
                      ) {
                        <div class="input-error">
                          同じ番号の行が既にあります
                        </div>
                      }
                    }
                  </div>
                  <div class="input-with-error tag-cell">
                    <app-multiple-select
                      [ariaLabel]="
                        section.numberLabel +
                        ' ' +
                        (row.controls.phoneNumber.value.trim() || '未入力') +
                        ' のタグ'
                      "
                      [items]="tagItemsForRow(row)"
                      [formControl]="row.controls.tagMasterIds"
                      [showError]="
                        row.controls.tagMasterIds.touched &&
                        row.controls.tagMasterIds.invalid
                      "
                      (changeSelected)="onTagSelectionChange(row, $event)"
                    ></app-multiple-select>
                    @if (
                      row.controls.tagMasterIds.touched &&
                      row.controls.tagMasterIds.hasError('required')
                    ) {
                      <div class="input-error">タグを選択してください</div>
                    }
                  </div>
                  <button
                    type="button"
                    class="remove-row-button"
                    aria-label="行を削除"
                    (click)="removeTagMappingRow(section.formArray, $index)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }

              <button
                type="button"
                class="add-row-button"
                [disabled]="hasNoTagMasters"
                (click)="addTagMappingRow(section.formArray)"
              >
                <mat-icon>add</mat-icon>
                行を追加
              </button>
            </div>
          }
        </div>

        @if (formGroup.hasError('totalPairCountExceeded')) {
          <div class="input-error">
            マッピング件数 (番号×タグの組み合わせ) が上限 (1000)
            を超えています。行またはタグを減らしてください。
          </div>
        }

        <div class="footer">
          <button type="button" rectangle variant="secondary" (click)="close()">
            キャンセル
          </button>
          <button
            type="submit"
            rectangle
            variant="primary"
            [disabled]="isSaving || hasNoTagMasters || formGroup.invalid"
          >
            保存
          </button>
        </div>
      </form>
    }
  </div>
</div>
